import {useMainStore} from "../../state/store";
import {useAuthenticationStore} from "../../state/modules/authentication";


export function isAuthenticated() {
    const store = useAuthenticationStore();
    return store.authenticated;
}

export function isTwoFactorRequired() {
    const store = useMainStore();
    return false;
    return store.getters.currentUser.twoFactorRequired;
}

export function isSettingUpCompany() {
    const store = useMainStore();
    return false;
    return store.getters.currentCompany.in_setup;
}
